export default {
  brand: 'CrypPay',
  transferHint: 'Please transfer to the address below',
  rechargeAmount: 'Amount',
  rechargeAddress: 'Deposit address',
  scanTip: 'Scan with your wallet to pay',
  copy: 'Copy',
  copied: 'Copied',
  copyFail: 'Copy failed',
  networkFee: 'Network fee',
  eta: 'Estimated arrival',
  etaVal: '~ 15 - 30 mins',
  actualArrival: 'You will receive',
  noticeTitle: 'Important',
  notice1: 'Only send to the QR code or address shown on this page.',
  notice2: 'Transfer amount must be exactly {amount} {coin}.',
  notice3: 'Wait for blockchain confirmation (usually 1 confirmation).',
  notice4: 'On-chain transfers are irreversible.',
  selectLang: 'Language',
  pending: 'Pending',
  paid: 'Paid',
  timeout: 'Expired',
  orderNo: 'Order',
  loading: 'Loading…',
  paramError: 'Invalid payment link',
  initFail: 'Failed to create order',
  paidSuccess: 'Payment successful',
  timedOut: 'Order expired'
}
